const DEFAULT_MAX_CONCURRENT_REQUESTS = 2;

let activeRequests = 0;
const pendingRequests = [];

const drainQueue = () => {
  while (
    activeRequests < DEFAULT_MAX_CONCURRENT_REQUESTS
    && pendingRequests.length > 0
  ) {
    const { request, resolve, reject } = pendingRequests.shift();
    activeRequests += 1;
    let requestResult;
    try {
      requestResult = request();
    } catch (error) {
      activeRequests -= 1;
      reject(error);
      continue;
    }
    Promise.resolve(requestResult)
      .then(resolve, reject)
      .finally(() => {
        activeRequests -= 1;
        drainQueue();
      });
  }
};

/**
 * Keep global badge/summary polling from opening a burst of API requests when
 * all top-level React providers mount or regain focus at the same time.
 */
export const runBackgroundRequest = (request) => new Promise((resolve, reject) => {
  pendingRequests.push({ request, resolve, reject });
  drainQueue();
});
